import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import { calculateGridHeight, showNotification } from '@/services/calculate'
import { formatCurrency } from '@/services/convert'
import {
  addGridRecord,
  updateGridRecord,
  highlightLinkRows,
} from '@/services/grid'
import { apiRequestArray, validateNumber } from '@/services/config'
import { AgGridVue } from 'ag-grid-vue'
import CurrencyRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import TextEditor from '@/components/DynamicComponents/Renderers/textEditor'
import InputNumberEditor from '@/components/DynamicComponents/Renderers/inputNumberEditor'
import SelectEditor from '@/components/DynamicComponents/Renderers/selectEditorDynamic'
import ActionRenderer from '@/components/DynamicComponents/Renderers/actionRendere'
import AutoCompleteRenders from '@/components/DynamicComponents/Renderers/autoCompleteRenders'
import ContractComponent from '@/components/DynamicComponents/Admin/MasterData/Project/Contract'
import CategoryCodeComponent from '@/components/DynamicComponents/Admin/MasterData/Project/CategoryCode'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    'add-category-code': CategoryCodeComponent,
    'add-contract': ContractComponent,
  },
  props: [
    'takeoffs',
    'columns',
    'costDetails',
    'singleClickEdit',
    'screenIndentifier',
    'sequence',
    'type',
    'tileTotal',
    'adjustmentTileTotal',
    'dropdownData',
    'tiles',
    'childTiles',
    'isArchive',
  ],
  data() {
    return {
      data: [],
      redrawTable: false,
      loading: false,
      gridOptions: {
        suppressCellSelection: true,
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        rowSelection: 'multiple',
        tooltipShowDelay: 0,
        rowDragManaged: true,
        stopEditingWhenGridLosesFocus: true,
        suppressContextMenu:
          this.costDetails.isAdjustmentTile || this.isArchive,
        defaultColDef: {
          suppressMovable: true,
          singleClickEdit: true,
          sortable: true,
          menuTabs: ['filterMenuTab'],
        },
      },
      columnDefs: null,
      frameworkComponents: null,
      width: '100%',
      height: '47rem',
      selectedRowKeys: [],
      selectedRows: [],
      formatCurrency: formatCurrency,
      pinnedTopRowData: [],
      isAddContract: false,
      isAddCategory: false,
      takeoffDetails: null,
      tileList: [],
      newTiles: [],
      postSort: null,
      isValidTakeoff: false,
      checked: false,
      getRowStyle: null,
    }
  },
  beforeMount() {
    this.loadingConfig()
    this.postSort = rowNodes => {
      const takeoffs = []
      for (let i = 0; i < rowNodes.length; i++) {
        takeoffs.push(rowNodes[i].data)
      }
      this.data = [...takeoffs]
    }
  },
  created() {
    this.$root.$off('cloneTileTakeoff')
    this.$root.$off('deleteTileTakeoff')
    this.$root.$off('handleTileChange')
    this.$root.$off('updateAdjustmentTakeoff')
    this.$root.$off('onLinkTakeoff')
    this.$root.$on('cloneTileTakeoff', this.cloneTakeoff)
    this.$root.$on('deleteTileTakeoff', this.deleteRecord)
    this.$root.$on('handleTileChange', this.updateTakeoff)
    this.$root.$on('updateAdjustmentTakeoff', this.updateAdjustmentTakeoff)
    this.$root.$on('onLinkTakeoff', this.onLinkTakeoff)
  },
  mounted() {
    this.loadingConfig()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        customFilter: CustomFilter,
        selectEditor: SelectEditor,
        costPriceCellRenderer: CurrencyRenderer,
        inputNumberEditor: InputNumberEditor,
        toolTipRenderer: ToolTipRenderer,
        textEditor: TextEditor,
        autocomplete: AutoCompleteRenders,
      }

      this.getRowStyle = params => {
        if (params.node.rowPinned) {
          return highlightLinkRows(params)
        }
      }
    },

    getContextMenuItems(params) {
      const isLinked = params.node && params.node.data.childTileId
      const childTileCount =
        !this.childTiles ||
        (this.childTiles && this.childTiles.tiles.length === 0)
      const isAdjustmentTakeoff =
        params.node && params.node.data.isAdjustmentTakeoff
      const record = params.node && params.node.data
      this.tileList = [...this.tiles, ...this.newTiles]
      const tileCount = this.tileList.length === 0

      var result = [
        {
          name: 'Move to new tile',
          disabled: isAdjustmentTakeoff,
          action: () => {
            this.linkTakeoffs(record, undefined, 'new')
          },
          icon: '<i class="fa fa-plus-square-o" />',
        },
        {
          name: 'Move to existing tile',
          disabled: tileCount || isAdjustmentTakeoff,
          icon: '<i class="fa fa-exchange" />',
          subMenu: this.showExistingTiles(record, this.tileList, 'existing'),
        },
        {
          name: 'Link to child',
          disabled: !!isLinked || childTileCount || isAdjustmentTakeoff,
          icon: '<i class="fa fa-link" />',
          subMenu: this.showExistingTiles(
            record,
            _.get(this.childTiles, 'tiles', []),
            'link',
          ),
        },
      ]
      return result
    },

    showExistingTiles(record, tiles, type) {
      const subMenu = []
      tiles.forEach(element => {
        subMenu.push({
          name: element.tileName,
          action: () => {
            this.linkTakeoffs(record, element.id, type, element.tileName)
          },
          icon: '<i class="fa fa-bars" />',
          tileDetails: element,
        })
      })
      return subMenu
    },

    linkTakeoffs(record, tileId, type, tileName) {
      let url = null
      switch (type) {
        case 'new':
        case 'existing':
          url = projectAPIs.project.asset.actualCost.level.tile.move(
            this.$route.params.id,
            this.costDetails.assetId,
            this.costDetails.levelId,
            tileId || 0,
          )
          break

        default:
          url = projectAPIs.project.asset.actualCost.level.takeoff.update(
            this.$route.params.id,
            this.costDetails.assetId,
            this.costDetails.levelId,
            this.costDetails.id,
          )
      }

      this.linkTakeoff(url, type, record, tileId, this.costDetails, tileName)
    },

    linkTakeoff(url, type, record, tileId, tileDetails, tileName) {
      let isValid = true
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data)
      const title = `You can't ${
        type === 'link' ? 'link' : 'move'
      } line item which is already linked to the tile on child level`
      const description = `Please unselect or unlink the above line items before  ${
        type === 'link' ? 'linking to child' : 'moving to other tile'
      }.`
      if (selectedData.length > 0) {
        const isLinked = selectedData.some(i => i.childTileId)
        var that = this
        if (isLinked) {
          isValid = false
          const h = this.$createElement
          this.$info({
            title: title,
            content: h('div', {}, [
              h(
                'div',
                { attrs: { class: 'linked-takeoff-div' } },
                that.showLinkedTakeoffs(h),
              ),
              h('p', { attrs: { class: 'warning-message' } }, description),
            ]),
            onOk() {},
          })
        }
      } else if (record && record.childTileId) {
        isValid = false
        var self = this
        const h = this.$createElement
        this.$info({
          title: title,
          content: h('div', {}, [
            h(
              'div',
              { attrs: { class: 'linked-takeoff-div' } },
              self.showLinkedTakeoff(h, [record], tileDetails),
            ),
            h('p', { attrs: { class: 'warning-message' } }, description),
          ]),
          onOk() {},
        })
      } else if (!record) {
        isValid = false
        const h = this.$createElement
        this.$info({
          title: 'Move Takeoffs',
          content: h('div', {}, [
            h(
              'p',
              { attrs: { class: 'warning-message' } },
              `Please select atleast one line item to ${
                type === 'link' ? 'link' : 'move'
              }`,
            ),
          ]),
          onOk() {},
        })
      }
      if (isValid) {
        this.loading = true
        let ids = selectedData.length > 0 ? selectedData : [record]
        ids = _.sortBy(ids, ['id'])
        let request = []
        switch (type) {
          case 'new':
          case 'existing':
            request = ids.map(i => i.id)
            break

          default:
            ids.forEach(element => {
              request.push({
                id: element.id,
                childTileId: tileId,
              })
            })
        }
        instance
          .patch(url, request)
          .then(response => {
            this.selectedRowKeys = []
            this.selectedRows = []
            this.gridOptions.api.forEachNodeAfterFilter(node => {
              node.setSelected(false)
            })
            switch (type) {
              case 'new':
              case 'existing':
                ids.map(element => {
                  const findIndex = this.data.findIndex(
                    val => val.id === element.id,
                  )
                  if (findIndex > -1) {
                    this.data.splice(findIndex, 1)
                  }
                })
                this.gridOptions.api.applyTransaction({
                  remove: selectedData.length > 0 ? selectedData : [record],
                })
                this.gridOptions.api.redrawRows()
                this.resetAdjustmentTakeoff()
                this.$emit('calculateTileTotal', this.data)
                this.calculateAdjustment()
                this.showHighlightTab()
                break

              default:
                const newData = [...this.data]
                ids.forEach(element => {
                  const index = this.data.findIndex(
                    val => val.id === element.id,
                  )
                  if (index > -1) {
                    newData[index].childTileId = tileId
                    newData[index].tileName = tileName
                    const itemsToUpdate = updateGridRecord(
                      this.gridOptions,
                      newData[index],
                      newData[index],
                    )
                    this.gridOptions.api.applyTransaction({
                      update: itemsToUpdate,
                    })
                  }
                })
                this.data = [...newData]
                this.gridOptions.api.redrawRows()
                this.showHighlightTab()
                this.$emit('onUpdate', true)
            }
            this.$emit('reloadLevels')
          })
          .catch(err => {
            this.loading = false
            errorService(err)
          })
      }
    },

    showLinkedTakeoff(h, data, tileDetails) {
      const row = []
      data
        .filter(i => i.childTileId)
        .forEach(element => {
          row.push(
            h(
              'p',
              { attrs: { class: 'linked-takeoff' } },
              `${tileDetails.tileName} ${element.takeoff}`,
            ),
          )
        })
      return row
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    getData(params) {
      const takeoffs = [...this.takeoffs]
      const displayColumns = this.refreshColumns()
      this.columnDefs = displayColumns
      params.api.setColumnDefs(displayColumns)
      params.api.sizeColumnsToFit()
      this.isValidTakeoff = takeoffs.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
      if (this.sequence > 1) {
        this.pinnedTopRowData = takeoffs.filter(i => i.isAdjustmentTakeoff)
      }
      params.api.setRowData(takeoffs.filter(i => !i.isAdjustmentTakeoff))
      params.columnApi.applyColumnState({
        state: [
          {
            colId: 'isValidTakeoff',
            hide: !this.isValidTakeoff,
          },
          {
            colId: 'checkbox',
            hide: this.isArchive,
          },
          {
            colId: 'display',
            hide: this.isArchive,
          },
          {
            colId: 'action',
            hide: this.isArchive,
          },
        ],
      })
      if (this.isArchive) {
        params.api.sizeColumnsToFit()
      }
    },

    addTakeoff(flag) {
      this.loading = true
      let url = null
      switch (this.screenIndentifier) {
        case 'Project Actual Cost':
          url = projectAPIs.project.asset.actualCost.level.takeoff.add(
            this.$route.params.id,
            this.costDetails.assetId,
            this.costDetails.levelId,
            this.costDetails.id,
          )
          break
      }
      instance
        .post(url, {
          isAdjustmentTakeoff: flag,
        })
        .then(response => {
          this.loading = false
          let newData = [...this.data]
          newData = newData.concat(_.get(response.data, 'result', []))
          this.data = [...newData]
          var itemsToAdd = addGridRecord(_.get(response.data, 'result', {}))
          this.gridOptions.api.applyTransaction({
            add: itemsToAdd,
          })
          this.gridOptions.api.redrawRows()
          const result = _.get(response.data, 'result', [])
          const indexOfNewRecord = this.data.findIndex(
            val => val.id === result.id,
          )
          this.gridOptions.api.setFocusedCell(indexOfNewRecord, 'takeoff')
          this.gridOptions.api.startEditingCell({
            rowIndex: indexOfNewRecord,
            colKey: 'takeoff',
          })
          this.$emit('onUpdate', true)
          if (this.type === 'Level') {
            const total = this.data.reduce((total, takeoff) => {
              return total + (takeoff.unitCost ? takeoff.unitCost : 0)
            }, 0)
            this.$emit('calculateTotal', this.data, total)
          }
          this.showHighlightTab()
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    updateTakeoff(value, record, key, index, takeoffData, data, keyCode) {
      const findIndex = this.data.findIndex(val => val.id === record.id)
      if (findIndex > -1 || (record && record.isAdjustmentTakeoff)) {
        const newData = [...this.data]
        const currentValue =
          value === 0 ? value.toString() : !value ? '' : value
        const previousValue = !window.previousValue ? '' : window.previousValue
        if (
          (currentValue !== null &&
            previousValue.toString() !== currentValue.toString()) ||
          key === 'tileName'
        ) {
          let url
          let request
          let enabled = true
          let isValid = true
          const isPresent = this.selectedRowKeys.some(i => i === record.id)
          const ids = isPresent ? this.selectedRowKeys : [record.id]
          switch (this.screenIndentifier) {
            case 'Project Actual Cost':
              url = projectAPIs.project.asset.actualCost.level.takeoff.update(
                this.$route.params.id,
                this.costDetails.assetId,
                this.costDetails.levelId,
                this.costDetails.id,
              )
              break
          }
          const details = {
            contract: data,
            categoryCode: data,
            record: record,
            list: newData,
            value: value,
            takeoff: takeoffData,
            unit: data,
            costType: data,
            tile: data,
            selectedKeys: ids,
            key: key,
            screen: 'Actual Cost',
            selectedRows: this.selectedRows,
          }
          switch (key) {
            case 'costType':
              this.takeoffDetails = { ...record }
              const costType = data ? data.id : undefined
              isValid = validateNumber(costType, key, 'Cost Type', record)
              if (isValid) {
                request = apiRequestArray(details, index)
              }
              break
            case 'contract':
              this.takeoffDetails = { ...record }
              if (value === 'addContract') {
                this.isAddContract = true
                enabled = false
              } else {
                this.loading = true
                request = apiRequestArray(details, index)
              }
              break
            case 'categoryCode':
              this.takeoffDetails = { ...record }
              if (value === 'addCategory') {
                this.isAddCategory = true
                enabled = false
              } else {
                this.loading = true
                request = apiRequestArray(details, index)
              }
              break
            case 'takeoff':
              this.takeoffDetails = { ...record }
              this.loading = true
              request = apiRequestArray(details, index)
              break
            case 'unitCost':
              this.takeoffDetails = { ...record }
              isValid = validateNumber(value, key, 'Actual Cost', record)
              if (isValid || isValid.title) {
                if (isValid.title) {
                  showNotification('warning', 'Actual Cost', isValid.title)
                }
                request = apiRequestArray(details, index)
              }
              break
            default:
              request = apiRequestArray(details, index)
              break
          }
          if (enabled && isValid) {
            this.loading = true
            instance
              .patch(url, request)
              .then(response => {
                if (!record.isAdjustmentTakeoff) {
                  this.onUpdateTakeoff(
                    response.data,
                    record,
                    newData,
                    key,
                    keyCode,
                  )
                } else {
                  this.pinnedTopRowData = _.get(response.data, 'result', [])
                  this.$emit('onUpdate', true)
                  this.showHighlightTab()
                }
              })
              .catch(err => {
                this.loading = false
                errorService(err)
              })
          } else if (enabled) {
            setTimeout(() => {
              if (record.isAdjustmentTakeoff) {
                this.pinnedTopRowData = []
                this.pinnedTopRowData.push(this.takeoffDetails)
                this.takeoffDetails = null
                this.$emit('onUpdate', true)
              } else {
                this.resetRowData(index)
              }
            }, 100)
          }
        }
      }
    },

    onUpdateTakeoff(data, record, newData, key, keyCode) {
      _.get(data, 'result', []).forEach(element => {
        const index = this.data.findIndex(val => val.id === element.id)
        if (index > -1) {
          newData[index] = element
          const itemsToUpdate = updateGridRecord(
            this.gridOptions,
            newData[index],
            newData[index],
          )
          this.gridOptions.api.applyTransaction({
            update: itemsToUpdate,
          })
        } else if (element.isAdjustmentTakeoff) {
          if (this.sequence > 1) {
            this.pinnedTopRowData = []
            this.pinnedTopRowData.push(element)
          }
        }
      })
      this.data = [...newData]
      this.gridOptions.api.redrawRows()
      if (record) {
        const rowIndex = this.data.findIndex(val => val.id === record.id)
        this.setActiveCell(key, rowIndex, keyCode)
      }
      this.gridOptions.api.forEachNodeAfterFilter(node => {
        node.setSelected(false)
      })
      this.$emit('onUpdate', true)
      this.resetAdjustmentTakeoff()
      if (key === 'unitCost') {
        if (this.type === 'Level') {
          const total = this.data.reduce((total, takeoff) => {
            return total + (takeoff.unitCost ? takeoff.unitCost : 0)
          }, 0)
          this.$emit('calculateTotal', this.data, total)
        } else {
          this.$emit('calculateTileTotal', newData)
          this.calculateAdjustment()
        }
      } else {
        this.$emit('calculateTileTotal', newData)
      }
      this.isValidTakeoff = this.data.some(
        i =>
          typeof i.isValidTakeoff !== 'undefined' &&
          !i.isValidTakeoff &&
          !i.isAdjustmentTakeoff,
      )
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'isValidTakeoff',
            hide: !this.isValidTakeoff,
          },
        ],
      })
      this.showHighlightTab()
      if (this.checked) {
        this.sortTakeoffs(this.isValidTakeoff)
      }
    },

    deleteAllRecord() {
      if (this.selectedRowKeys.length > 0) {
        const isLinked = this.selectedRows.some(i => i.childTileId)
        var that = this
        if (isLinked) {
          const h = this.$createElement
          this.$info({
            title: `You can't delete line item which is linked to the tile on child level`,
            content: h('div', {}, [
              h(
                'div',
                { attrs: { class: 'linked-takeoff-div' } },
                that.showLinkedTakeoffs(h),
              ),
              h(
                'p',
                {},
                'Please unselect or unlink the above line items before deleting.',
              ),
            ]),
            onOk() {},
          })
        } else {
          this.$confirm({
            title: `Are you sure want to delete ${this.selectedRowKeys.length} records?`,
            content: h => (
              <div style="color:red">
                <p>
                  This action will delete all information related these rows.
                </p>
                <p>Please confirm.</p>
              </div>
            ),
            onOk() {
              that.confirmDelete(null)
            },
          })
        }
      } else {
        showNotification(
          'warning',
          'Cost Details',
          'Please select at least one line item!',
        )
      }
    },

    deleteRecord(record) {
      var that = this
      if (record.childTileId) {
        const h = this.$createElement
        this.$info({
          title: `You can't delete line item which is linked to the tile on child level`,
          content: h('div', {}, [
            h('p', { attrs: { class: 'linked-takeoff' } }, record.takeoff),
            h('p', {}, 'Please unlink the above line item before deleting.'),
          ]),
          onOk() {},
        })
      } else {
        this.$confirm({
          title: `Are you sure want to delete line item ?`,
          content: h => (
            <div style="color:red">
              <p>
                This action will delete all information related this line item.
              </p>
              <p>Please confirm.</p>
            </div>
          ),
          onOk() {
            that.confirmDelete(record)
          },
        })
      }
    },

    confirmDelete(record) {
      this.loading = true
      const url = projectAPIs.project.asset.actualCost.level.takeoff.delete(
        this.$route.params.id,
        this.costDetails.assetId,
        this.costDetails.levelId,
        this.costDetails.id,
      )
      const ids = record ? [record.id] : this.selectedRowKeys
      instance
        .delete(url, { data: ids })
        .then(response => {
          ids.map(element => {
            const findIndex = this.data.findIndex(val => val.id === element)
            if (findIndex > -1) {
              this.data.splice(findIndex, 1)
            }
          })
          if (record) {
            this.gridOptions.api.applyTransaction({ remove: [record] })
          } else {
            this.gridOptions.api.applyTransaction({
              remove: this.selectedRows,
            })
          }
          this.selectedRowKeys = []
          this.selectedRows = []
          this.loading = false
          this.$emit('onUpdate', true)
          this.resetAdjustmentTakeoff()
          this.$emit('calculateTileTotal', this.data)
          this.calculateAdjustment()
          const isValid = this.data.some(
            i =>
              typeof i.isValidTakeoff !== 'undefined' &&
              !i.isValidTakeoff &&
              !i.isAdjustmentTakeoff,
          )
          this.gridOptions.columnApi.applyColumnState({
            state: [
              {
                colId: 'isValidTakeoff',
                hide: !isValid,
              },
            ],
          })
          this.showHighlightTab()
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    cloneTakeoff(id) {
      this.loading = true
      let url = null
      let newData = [...this.data]
      switch (this.screenIndentifier) {
        case 'Project Actual Cost':
          url = projectAPIs.project.asset.actualCost.level.takeoff.clone(
            this.$route.params.id,
            this.costDetails.assetId,
            this.costDetails.levelId,
            this.costDetails.id,
          )
          break
      }
      const isPresent = this.selectedRowKeys.some(i => i === id)
      const ids = isPresent ? this.selectedRowKeys : [id]
      instance
        .put(url, ids)
        .then(response => {
          _.get(response.data, 'result', []).forEach(element => {
            newData = newData.concat(_.get(response.data, 'result', []))
          })
          this.loading = false
          this.data = [...newData]
          this.gridOptions.api.applyTransaction({
            add: _.get(response.data, 'result', []),
          })
          this.gridOptions.api.forEachNodeAfterFilter(node => {
            node.setSelected(false)
          })
          this.$emit('onUpdate', true)
          this.resetAdjustmentTakeoff()
          this.$emit('calculateTileTotal', this.data)
          this.calculateAdjustment()
          this.showHighlightTab()
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    getWindowSize() {
      this.height = calculateGridHeight('gridTable', true, false)
    },

    gridSizeChanged(e) {
      this.gridOptions.api.sizeColumnsToFit()
    },

    setActiveCell(key, index, keyCode) {
      const focusedCell = this.gridOptions.api.getFocusedCell()
      let focusKey
      if (focusedCell) {
        switch (key) {
          case 'costType':
            focusKey = 'contract'
            break
          case 'contract':
            focusKey = 'categoryCode'
            break
          case 'categoryCode':
            focusKey = 'takeoff'
            break
          case 'takeoff':
            focusKey = 'unitCost'
            break
          case 'unitCost':
            focusKey = 'note'
            break
          case 'note':
            if (this.costDetails.isAdjustmentTile) {
              if (index < this.data.length - 1) {
                focusKey = 'costType'
                index = index + 1
              }
            } else {
              focusKey = 'tileName'
            }
            break
          case 'tileName':
            if (index < this.data.length - 1) {
              focusKey = 'costType'
              index = index + 1
            }
            break
          default:
            break
        }
        if (index <= this.data.length - 1) {
          this.gridOptions.api.setFocusedCell(index, focusKey)
          this.gridOptions.api.startEditingCell({
            rowIndex: index,
            colKey: focusKey,
          })
        }
      }
    },

    onRowDragEnd(e) {
      this.loading = true
      const request = []
      this.data.forEach((i, index) => {
        request.push({
          id: i.id,
          sequence: index + 1,
        })
      })
      this.reorder(request)
    },

    onRowDragLeave(e) {
      this.onRowDragEnd(e)
    },

    reorder(request) {
      let url
      switch (this.screenIndentifier) {
        case 'Project Actual Cost':
          url = projectAPIs.project.asset.actualCost.level.takeoff.reorder(
            this.$route.params.id,
            this.costDetails.assetId,
            this.costDetails.levelId,
            this.costDetails.id,
          )
          break
      }
      instance
        .patch(url, request)
        .then(response => {
          this.selectedRowKeys = []
          this.gridOptions.api.deselectAll()
          this.loading = false
          this.$emit('onUpdate', true)
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    calculateAdjustment() {
      let tileTotal = this.tileTotal
      let adjustmentTotal = this.adjustmentTileTotal
      if (this.data && this.data.length > 0) {
        tileTotal = this.data
          .filter(i => !i.isAdjustmentTakeoff)
          .reduce((total, takeoff) => {
            return total + (takeoff.unitCost ? takeoff.unitCost : 0)
          }, 0)

        adjustmentTotal = this.data
          .filter(i => i.isAdjustmentTakeoff)
          .reduce((total, takeoff) => {
            return total + (takeoff.unitCost ? takeoff.unitCost : 0)
          }, 0)
      }
      return this.costDetails.parentTotal - (tileTotal + adjustmentTotal)
    },

    showLinkedTakeoffs(h) {
      const row = []
      this.selectedRows
        .filter(i => i.childTileId)
        .forEach(element => {
          row.push(
            h('p', { attrs: { class: 'linked-takeoff' } }, element.takeoff),
          )
        })
      return row
    },

    updateAdjustmentTakeoff(message) {
      this.loading = false
      this.$notification.destroy()
      const data = JSON.parse(message.message)
      if (data.Status === 'ERROR') {
        showNotification('warning', 'Cost Details', _.get(data, 'Result', ''))
      }
    },

    addContract(data, flag) {
      this.isAddContract = flag
      const newData = [...this.data]
      const index = newData.findIndex(i => i.id === this.takeoffDetails.id)
      if (data) {
        this.gridOptions.api.redrawRows()
        this.updateTakeoff(
          data.contract,
          this.takeoffDetails,
          'contract',
          index,
          null,
          data,
          null,
        )
        this.$root.$emit('addContract', data)
      } else {
        this.resetRowData(index)
      }
    },

    addCategory(data, contracts, flag) {
      this.isAddCategory = flag
      const newData = [...this.data]
      const index = newData.findIndex(i => i.id === this.takeoffDetails.id)
      if (data) {
        const category = {
          id: data.id,
          masterId: data.masterId,
          option: `${data.categoryCode} - ${data.description}`,
          value: `${data.categoryCode} - ${data.description}`,
          description: data.description,
          contractDetailsId: data.mContractDetailsId,
        }
        this.gridOptions.api.redrawRows()
        this.updateTakeoff(
          data.categoryCode,
          this.takeoffDetails,
          'categoryCode',
          index,
          null,
          category,
          null,
        )
        this.$root.$emit('addCategoryCode', category, contracts)
      } else {
        this.resetRowData(index)
      }
    },

    resetAdjustmentTakeoff() {
      const tileTotal = this.data.reduce((total, takeoff) => {
        return total + (takeoff.unitCost ? takeoff.unitCost : 0)
      }, 0)
      const pinnedRowData = this.pinnedTopRowData
      if (pinnedRowData.length > 0) {
        let cost = _.get(this.costDetails, 'parentTotal', 0) - tileTotal
        pinnedRowData[0].unitCost = cost
        if (!pinnedRowData[0].isManuallyUpdated) {
          if (
            String(cost) === '-0' ||
            String(cost) === '-0.0' ||
            String(cost) === '-0.00'
          ) {
            cost = 0
          }
          const contract = this.dropdownData.contract.find(
            i =>
              i.value.split(' - ')[0] ===
                (pinnedRowData[0].unitCost < 0 ? '1.00' : '10.00') ||
              i.value.split(' - ')[0] ===
                (pinnedRowData[0].unitCost < 0 ? '1' : '10'),
          )
          const category = this.dropdownData.category.find(
            i => i.value.split(' - ')[0] === '10000',
          )
          const costType = this.dropdownData.costType.find(
            i =>
              i.costType ===
              (pinnedRowData[0].unitCost < 0
                ? 'Building Indirect'
                : 'Hard Cost (No Indirects)'),
          )
          pinnedRowData[0].mContractId = contract ? contract.id : undefined
          pinnedRowData[0].contract = contract
            ? contract.value.split(' - ')[0]
            : undefined
          pinnedRowData[0].mCategoryCodeId = category ? category.id : undefined
          pinnedRowData[0].categoryCode =
            pinnedRowData[0].unitCost < 0
              ? undefined
              : category
                ? category.value.split(' - ')[0]
                : undefined
          pinnedRowData[0].mCostTypeId = costType ? costType.id : undefined
          pinnedRowData[0].costType = costType ? costType.costType : undefined
        }
        this.pinnedTopRowData = pinnedRowData
        this.gridOptions.api.setPinnedTopRowData(pinnedRowData)
      }
    },

    unlinkCostDetails() {
      if (this.selectedRowKeys.length > 0) {
        const linkedTakeoffs = this.selectedRows.filter(i => i.childTileId)
        if (linkedTakeoffs.length > 0) {
          const that = this
          this.$confirm({
            title: `Are you sure want to unlink ${this.selectedRowKeys.length} cost details?`,
            content: h => (
              <div style="color:red">
                <p>This action will unlink cost details related these rows.</p>
                <p>Please confirm.</p>
              </div>
            ),
            onOk() {
              that.confirmUnlink(linkedTakeoffs)
            },
          })
        } else {
          showNotification(
            'warning',
            'Cost Details',
            'No line items to unlink!',
          )
        }
      } else {
        showNotification(
          'warning',
          'Cost Details',
          'Please select at least one line item!',
        )
      }
    },

    confirmUnlink(linkedTakeoffs) {
      const newData = [...this.data]
      const url = projectAPIs.project.asset.actualCost.level.takeoff.update(
        this.$route.params.id,
        this.costDetails.assetId,
        this.costDetails.levelId,
        this.costDetails.id,
      )
      const request = []
      linkedTakeoffs.forEach(element => {
        request.push({
          id: element.id,
          childTileId: null,
        })
      })
      this.loading = true
      instance
        .patch(url, request)
        .then(response => {
          this.onUpdateTakeoff(response.data, null, newData, null, null)
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    resetRowData(index) {
      const newData = [...this.data]
      newData[index] = this.takeoffDetails
      this.data = [...newData]
      this.gridOptions.api.redrawRows()
      const itemsToUpdate = updateGridRecord(
        this.gridOptions,
        this.takeoffDetails,
        newData[index],
      )
      this.gridOptions.api.applyTransaction({
        update: itemsToUpdate,
      })
      this.gridOptions.api.redrawRows()
      const focusedCell = this.gridOptions.api.getFocusedCell()
      if (focusedCell) {
        this.gridOptions.api.setFocusedCell(
          focusedCell.rowIndex,
          focusedCell.column.colId,
        )
        this.gridOptions.api.startEditingCell({
          rowIndex: focusedCell.rowIndex,
          colKey: focusedCell.column.colId,
        })
      }
      this.takeoffDetails = null
      this.$emit('onUpdate', true)
    },

    onLinkTakeoff(data) {
      this.newTiles = []
      this.loading = false
      if (data.Result) {
        const isPresent = this.tileList.some(i => i.id === data.Result.Id)
        if (!isPresent) {
          this.newTiles.push({
            assetId: data.Result.AssetId,
            id: data.Result.Id,
            isAdjustmentTile: data.Result.IsAdjustmentTile,
            isLinked: data.Result.IsLinked,
            levelId: data.Result.LevelId,
            projectId: data.Result.ProjectId,
            sequence: data.Result.Sequence,
            tileName: data.Result.TileName,
          })
        }
      }
    },

    refreshColumns() {
      const displayColumns = this.columns
      displayColumns.map(col => {
        const align = col.field === 'unitCost' ? 'right' : 'left'
        if (col.headerName && col.field !== 'action') {
          col.cellStyle = param => highlightLinkRows(param, align)
          col.filter = 'customFilter'
          col.menuTabs = this.checked ? [] : ['filterMenuTab']
          col.sortable = !this.checked
        }
        return col
      })

      return displayColumns
    },

    sortTakeoffs(value) {
      let sort = 'asc'
      let key = 'sequence'
      this.checked = value
      this.gridOptions.columnApi.applyColumnState({
        defaultState: { sort: null },
      })
      this.gridOptions.api.setFilterModel(null)
      if (value) {
        sort = 'asc'
        key = 'isValidTakeoff'
      }
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: key,
            sort: sort,
          },
          {
            colId: 'display',
            hide: value,
          },
        ],
        defaultState: { sort: null },
      })
      const displayColumns = this.refreshColumns()
      this.gridOptions.api.setColumnDefs(displayColumns)
      this.gridOptions.api.sizeColumnsToFit()
    },

    filterChanged() {
      this.isValidTakeoff = this.data.some(
        i =>
          typeof i.isValidTakeoff !== 'undefined' &&
          !i.isValidTakeoff &&
          !i.isAdjustmentTakeoff,
      )
      this.$emit('calculateTileTotal', this.data)
    },

    showHighlightTab() {
      const takeoffs = [...this.data, ...this.pinnedTopRowData]
      this.isValidTakeoff = takeoffs.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
      this.$emit('showHighlightTab', !this.isValidTakeoff)
    },
  },
}
